<template>
    <div class="container table-data">
<!--        <a id="downLoad" style="display: none !important;" :href="downloadUrl" :download="downloadName"></a>-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" ref="queryForm">
            <el-form-item label="日期：" label-width="80px">
                <el-date-picker
                    v-model="date"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    placeholder="请选择日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="addItem">生成报表</el-button>
            </el-form-item>
            <el-form-item>
                <el-button @click="refresh">重置</el-button>
            </el-form-item>
        </el-form>
        <p style="font-size: 12px;padding-bottom: 16px;padding-top: 20px;color: red;">
            <el-button size="mini" style="margin-right: 20px;" @click="fetchData">刷新</el-button>
            提示：报表生成需要一点时间，手动刷新网页查看报表最新状态
        </p>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                v-for="(item, index) in tableColumn"
                :prop="item.id"
                :label="item.name"
                :show-overflow-tooltip="true"
                :key="index"
                :width="item.width">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status == 4" @click="downloadItem(scope.row)" size="mini" class="tab-btn" type="text">
                      下载报表
                    </el-button>
                    <el-button v-if="scope.row.status != 15" @click.native.prevent="deleteItem(scope.row)" size="mini" type="text">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "downloadList",
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    let max = moment(new Date()).format('YYYY-MM-DD');
                    // return的值,true是不可以操作选择,false可以操作选择,比如下面这个判断就只能选择今天之后的时间
                    return time.getTime() > new Date(max + " 00:00:00").getTime()
                },
            },
            token: '',
            userName: '',
            templateId: 295, // 线上 295，测试 289
            pageSizes: [10,20,30,40,50],//自定义分页条数
            queryFormLabelWidth: '100px',//自定义查询表单label宽度
            queryForm: {
                pageSize: 10,
                pageNo: 1,
            },
            date: ['', ''],
            tableColumn: [
              { id: 'id', name: '编号', width: '120' },
              { id: 'parms', name: '查询时间纬度' },
              { id: 'createUser', name: '操作人', width: '240' },
              { id: 'statusStr', name: '状态', width: '100' },
            ],
            tableData: [],
            loading: false,
            total: 0,
        }
    },
    created() {
        this.token =  localStorage.getItem('token');
        this.userName = localStorage.getItem('userName');
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        isChinese(s) {
          return /[\u4e00-\u9fa5]/.test(s);
        },
        ch2Unicdoe(str){
            if(!str){ return; }
            let unicode = '';
            for (let i = 0; i <  str.length; i++) {
                let temp = str.charAt(i);
                if(this.isChinese(temp)){
                    unicode += '\\u' +  temp.charCodeAt(0).toString(16);
                }
                else{
                  unicode += temp;
                }
            }
            return unicode;
        },
        /** 切换每页显示条数操作 */
        handleSizeChange(val) {
            this.queryForm.pageNo = 1;
            this.queryForm.pageSize = val;
            this.fetchData();
        },
        /** 切换页码操作 */
        handleCurrentChange(val) {
            this.queryForm.pageNo = val;
            this.fetchData();
        },
        /** 重置 */
        refresh() {
            this.date = [];
            this.queryForm.pageNo = 1;
            this.queryForm.pageSize = 10;
            this.fetchData();
        },
        /** 生成报表 */
        addItem() {
            if (!this.date[0] || this.date[0] == '' || !this.date[1] || this.date[1] == '') {
                return this.$message.warning('请选择时间');
            }
            if(new Date(this.date[1]).getTime() - new Date(this.date[0]).getTime() < 0) {
                return this.$message.warning('开始时间不能大于结束时间');
            }
            let params = {
                templateId: this.templateId,
                token: this.token,
                userName: this.userName,
                startDate: moment(this.date[0]).format('YYYY-MM-DD') + " 00:00:00",
                endDate: moment(this.date[1]).format('YYYY-MM-DD') + " 00:00:00",
            }
            this.$api.post_bip(this.$apiUrl.commercialGdReportListAdd, params, (res) => {
                if (res.msg == "成功" && res.result) {
                    this.$message.success('报表查询中，请稍后');
                    this.fetchData();
                } else {
                    this.$message.warning(res.msg);
                }
            }, err => {
                this.$message.warning(err.msg);
            })
        },
        /** 下载报表 */
        downloadItem(row) {
            // 开发
            let href = 'https://bip.anlaiye.com' + this.$apiUrl.commercialGdReportDownload + '?id=' + row.id + "&fileType=1";
            window.open(href);
        },
        /** 删除报表 */
        deleteItem(row) {
            this.$confirm('你是否确认删除这个报表?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params ={
                    id: row.id,
                    token: this.token,
                    userName: this.userName
                }
                this.$api.post_bip(this.$apiUrl.commercialGdReportDelete,params,(res)=>{
                    this.$message.success('删除成功');
                    if (this.queryForm.pageSize * (this.queryForm.pageNo - 1) >= this.total) {
                        this.queryForm.pageNo = this.queryForm.pageNo - 1;
                    }
                    this.fetchData();
                },(res)=>{
                    this.$message.warning(res.message);
                },'oc')
            }).catch(() => {

            })
        },
        /** 获取列表数据 */
        fetchData() {
            let params = {
              templateId: this.templateId,
              token: this.token,
              userName: this.ch2Unicdoe(this.userName),
            }
            this.loading = true;
            this.$api.get_bip(this.$apiUrl.commercialGdReportList, params, (res) => {
                if (res.msg == "成功" && res.result) {
                    this.total = res.data.total;
                    this.tableData = res.data.page_list;
                    this.loading = false;
                } else {
                    this.$message.warning(res.msg);
                }
            }, err => {
                this.$message.warning(err.msg);
            })
        }
    }
}
</script>

<style scoped>
    .tab-btn {
        font-size: 12px !important;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// list.vue?56fa8e0f